var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "day-configurator-time-planning d-flex flex-column" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showIntro
          ? _c(
              "div",
              {
                staticClass: "intro-overlay d-md-none",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.showIntro = false
                  }
                }
              },
              [
                _c("div", { staticClass: "text-center mt-56" }, [
                  _c("p", { staticClass: "text-bold mb-32" }, [
                    _vm._v(
                      "Duid een tijdslot aan om een activiteit toe te voegen."
                    )
                  ]),
                  _vm._v(" "),
                  _c("a", { staticClass: "text-accent font-weight-light" }, [
                    _vm._v("Begrepen")
                  ])
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "time-slots" },
        _vm._l(_vm.totalSlots, function(slot, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "time-slot",
              class: {
                hour: index % _vm.slotsPerHour === 0,
                occupied: _vm.occupiedSlots.includes(index)
              },
              style: { height: _vm.hourSpacing / _vm.slotsPerHour + "px" }
            },
            [
              _vm.occupiedSlots.includes(index)
                ? [
                    index % _vm.slotsPerHour === 0
                      ? _c("span", { staticClass: "slot-label" }, [
                          _vm._v(
                            _vm._s(_vm.start + index / _vm.slotsPerHour + ":00")
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "slot-inner" })
                  ]
                : [
                    _c(
                      "drop",
                      {
                        staticClass: "h-100",
                        on: {
                          dragover: function($event) {
                            return _vm.handleDragOver($event, index)
                          },
                          drop: _vm.handleDrop,
                          dragleave: _vm.removeHoverState
                        }
                      },
                      [
                        index % _vm.slotsPerHour === 0
                          ? _c("span", { staticClass: "slot-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.start + index / _vm.slotsPerHour + ":00"
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "slot-inner",
                          class: { over: _vm.currentHoverIndex === index },
                          on: {
                            mouseover: function($event) {
                              return _vm.handleMouseOver(index)
                            },
                            click: function($event) {
                              return _vm.clickTimeSlot(index)
                            }
                          }
                        })
                      ]
                    )
                  ]
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isHovering
          ? _c(
              "div",
              {
                staticClass:
                  "card hover-card card-two-row d-flex align-items-center justify-content-between",
                class: _vm.hoverPayload.type + "-card",
                style: { top: _vm.hoverTopOffset }
              },
              [
                _vm.hoverPayload.type === "activity"
                  ? [
                      _c("div", { staticClass: "left-part" }, [
                        _c("img", {
                          staticClass:
                            "thumbnail align-self-start align-self-md-center",
                          attrs: {
                            src:
                              _vm.hoverPayload.data.acf.content.images[0].sizes
                                .medium_large,
                            alt: _vm.hoverPayload.data.post_title
                              ? _vm.hoverPayload.data.post_title
                              : _vm.hoverPayload.data.title.rendered
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "splitter" }, [
                          _c("div", { staticClass: "top" }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.hoverPayload.data.post_title
                                    ? _vm.hoverPayload.data.post_title
                                    : _vm.hoverPayload.data.title.rendered
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bottom" }, [
                            _c("p", { staticClass: "actions" }, [
                              _c("a", { staticClass: "comment" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.translations.day_planning.add_remark
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("a", [
                                _vm._v(
                                  _vm._s(_vm.translations.day_planning.modify)
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right-part" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getTimeForIndex(
                                _vm.currentHoverFirstSlotIndex
                              ) +
                                " - " +
                                _vm.getTimeForIndex(
                                  _vm.currentHoverFirstSlotIndex +
                                    _vm.slotsPerHour
                                )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("1 uur")])
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.hoverPayload.type === "speaker" ||
                _vm.hoverPayload.type === "location" ||
                _vm.hoverPayload.type === "staticItem"
                  ? [
                      _c("div", { staticClass: "left-part" }, [
                        _c("img", {
                          staticClass:
                            "thumbnail align-self-start align-self-md-center",
                          attrs: {
                            src:
                              _vm.hoverPayload.data.acf.image.sizes
                                .medium_large,
                            alt: _vm.hoverPayload.data.post_title
                              ? _vm.hoverPayload.data.post_title
                              : _vm.hoverPayload.data.title.rendered
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "splitter" }, [
                          _c("div", { staticClass: "top" }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.hoverPayload.data.post_title
                                    ? _vm.hoverPayload.data.post_title
                                    : _vm.hoverPayload.data.title.rendered
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bottom" }, [
                            _c("p", { staticClass: "actions" }, [
                              _c("a", { staticClass: "comment" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.translations.day_planning.add_remark
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("a", [
                                _vm._v(
                                  _vm._s(_vm.translations.day_planning.modify)
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right-part" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getTimeForIndex(
                                _vm.currentHoverFirstSlotIndex
                              ) +
                                " - " +
                                _vm.getTimeForIndex(
                                  _vm.currentHoverFirstSlotIndex +
                                    _vm.slotsPerHour
                                )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("1 uur")])
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.hoverPayload.type === "own_activity"
                  ? [
                      _c("div", { staticClass: "left-part" }, [
                        _c("div", { staticClass: "splitter" }, [
                          _c("div", { staticClass: "top" }, [
                            _c("span", { staticClass: "icon" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.translations.day_planning.own_activity
                                    .icon
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.hoverPayload.data.name))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bottom" }, [
                            _c("p", { staticClass: "actions" }, [
                              _c("a", { staticClass: "comment" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.translations.day_planning.add_remark
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("a", [
                                _vm._v(
                                  _vm._s(_vm.translations.day_planning.modify)
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right-part" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getTimeForIndex(
                                _vm.currentHoverFirstSlotIndex
                              ) +
                                " - " +
                                _vm.getTimeForIndex(
                                  _vm.currentHoverFirstSlotIndex +
                                    _vm.slotsPerHour
                                )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("1 uur")])
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.hoverPayload.type === "break"
                  ? [
                      _c("div", { staticClass: "left-part" }, [
                        _c("div", { staticClass: "splitter" }, [
                          _c("div", { staticClass: "top" }, [
                            _c("span", { staticClass: "icon" }, [
                              _vm._v(
                                _vm._s(_vm.translations.day_planning.break.icon)
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.translations.day_planning.break.label
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bottom" }, [
                            _c("p", { staticClass: "actions" }, [
                              _c("a", { staticClass: "comment" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.translations.day_planning.add_remark
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("a", [
                                _vm._v(
                                  _vm._s(_vm.translations.day_planning.modify)
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right-part" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getTimeForIndex(
                                _vm.currentHoverFirstSlotIndex
                              ) +
                                " - " +
                                _vm.getTimeForIndex(
                                  _vm.currentHoverFirstSlotIndex +
                                    _vm.slotsPerHour
                                )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("1 uur")])
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-overlay" },
        _vm._l(_vm.schedule.activities, function(item, index) {
          return _c(
            "vue-draggable-resizable",
            {
              key: index,
              class: item.type + "-card",
              attrs: {
                "min-height": _vm.hourSpacing / _vm.slotsPerHour,
                parent: true,
                handles: ["tm", "bm"],
                axis: "y",
                y: _vm.initialResizeOffsets[index],
                h: item.duration * 2,
                grid: [
                  _vm.hourSpacing / _vm.slotsPerHour,
                  _vm.hourSpacing / _vm.slotsPerHour
                ]
              },
              on: {
                resizing: function($event) {
                  return _vm.resizing(index)
                },
                resizestop: _vm.onResizestop,
                dragging: function($event) {
                  return _vm.dragging(index)
                },
                dragstop: _vm.onDragstop
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "card planned-card d-flex h-100 align-items-center justify-content-md-between",
                  class:
                    item.duration <= 30
                      ? item.duration <= 15
                        ? "card-single-row card-tiny"
                        : "card-single-row"
                      : "card-two-row"
                },
                [
                  item.type === "listed" && _vm.getExternalItem(item) != null
                    ? [
                        _c(
                          "div",
                          { staticClass: "left-part" },
                          [
                            item.data.external_type === "activity"
                              ? [
                                  item.duration >= 45
                                    ? _c("img", {
                                        staticClass:
                                          "thumbnail align-self-start align-self-md-center",
                                        attrs: {
                                          src: _vm.getExternalItem(item).acf
                                            .content.images[0].sizes
                                            .medium_large,
                                          alt: _vm.getExternalItem(item)
                                            .post_title
                                            ? _vm.getExternalItem(item)
                                                .post_title
                                            : _vm.getExternalItem(item).title
                                                .rendered
                                        }
                                      })
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            item.data.external_type === "speaker" ||
                            item.data.external_type === "location" ||
                            item.data.external_type === "staticItem"
                              ? [
                                  item.duration >= 45
                                    ? _c("img", {
                                        staticClass:
                                          "thumbnail align-self-start align-self-md-center",
                                        attrs: {
                                          src: _vm.getExternalItem(item).acf
                                            .image.sizes.medium_large,
                                          alt: _vm.getExternalItem(item)
                                            .post_title
                                            ? _vm.getExternalItem(item)
                                                .post_title
                                            : _vm.getExternalItem(item).title
                                                .rendered
                                        }
                                      })
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "splitter" }, [
                              _c("div", { staticClass: "top" }, [
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getExternalItem(item).post_title
                                        ? _vm.getExternalItem(item).post_title
                                        : _vm.getExternalItem(item).title
                                            .rendered
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "d-md-none" }, [
                                  _c(
                                    "span",
                                    { staticClass: "d-inline-block mr-16" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.start +
                                            " - " +
                                            _vm.getTimeForIndex(
                                              Math.floor(
                                                _vm.getIndexForTime(
                                                  item.start
                                                ) +
                                                  (item.duration / 60) *
                                                    _vm.slotsPerHour
                                              )
                                            )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "d-inline-block" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.activityDurationString(
                                            item.duration
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                item.data.remarks && item.data.remarks != ""
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "tooltip-wrapper icon-info ml-16"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "tooltip-icon",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.svg("info-icon")
                                              )
                                            }
                                          },
                                          [_vm._v("X")]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "tooltip tooltip-top",
                                          domProps: {
                                            innerHTML: _vm._s(item.data.remarks)
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "bottom" }, [
                                _vm.canEdit
                                  ? _c("p", { staticClass: "actions" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "comment",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.showRemarkPopup(
                                                $event,
                                                { index: index, data: item }
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.data.remarks &&
                                                item.data.remarks != ""
                                                ? _vm.translations.day_planning
                                                    .change_remark
                                                : _vm.translations.day_planning
                                                    .add_remark
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.showTooltip($event, {
                                                index: index,
                                                data: item
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translations.day_planning
                                                .modify
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-part" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.activityStartEndString(item)))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.activityDurationString(item.duration))
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  item.type === "catering"
                    ? [
                        _c("div", { staticClass: "left-part" }, [
                          _c("div", { staticClass: "splitter" }, [
                            _c("div", { staticClass: "top" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-row align-items-center"
                                },
                                [
                                  _c("span", { staticClass: "icon" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translations.day_planning[
                                          item.data.type
                                        ].icon
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translations.day_planning[
                                          item.data.type
                                        ].label
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "d-md-none" }, [
                                _c(
                                  "span",
                                  { staticClass: "d-inline-block mr-16" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.start +
                                          " - " +
                                          _vm.getTimeForIndex(
                                            Math.floor(
                                              _vm.getIndexForTime(item.start) +
                                                (item.duration / 60) *
                                                  _vm.slotsPerHour
                                            )
                                          )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "d-inline-block" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.activityDurationString(item.duration)
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              item.data.remarks && item.data.remarks != ""
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "tooltip-wrapper icon-info ml-16"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "tooltip-icon",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.svg("info-icon")
                                            )
                                          }
                                        },
                                        [_vm._v("X")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "tooltip tooltip-top",
                                        domProps: {
                                          innerHTML: _vm._s(item.data.remarks)
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "bottom" }, [
                              _vm.canEdit
                                ? _c("p", { staticClass: "actions" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "comment",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showRemarkPopup($event, {
                                              index: index,
                                              data: item
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.data.remarks &&
                                              item.data.remarks != ""
                                              ? _vm.translations.day_planning
                                                  .change_remark
                                              : _vm.translations.day_planning
                                                  .add_remark
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showTooltip($event, {
                                              index: index,
                                              data: item
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translations.day_planning.modify
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-part" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.activityStartEndString(item)))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.activityDurationString(item.duration))
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  item.type === "own"
                    ? [
                        _c("div", { staticClass: "left-part" }, [
                          _c("div", { staticClass: "splitter" }, [
                            _c("div", { staticClass: "top" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-row align-items-center"
                                },
                                [
                                  _c("span", { staticClass: "icon" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translations.day_planning
                                          .own_activity.icon
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(item.data.name))])
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "d-md-none" }, [
                                _c(
                                  "span",
                                  { staticClass: "d-inline-block mr-16" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.start +
                                          " - " +
                                          _vm.getTimeForIndex(
                                            Math.floor(
                                              _vm.getIndexForTime(item.start) +
                                                (item.duration / 60) *
                                                  _vm.slotsPerHour
                                            )
                                          )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "d-inline-block" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.activityDurationString(item.duration)
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              item.data.requests != null &&
                              item.data.requests != ""
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "tooltip-wrapper icon-person ml-16"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "tooltip-icon",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.svg("person-accent")
                                            )
                                          }
                                        },
                                        [_vm._v("X")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "tooltip tooltip-top" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "font-weight-normal mb-8"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.translations.day_planning
                                                    .own_activity.tooltip_label
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(_vm._s(item.data.requests))
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.data.remarks && item.data.remarks != ""
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "tooltip-wrapper icon-info ml-16"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "tooltip-icon",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.svg("info-icon")
                                            )
                                          }
                                        },
                                        [_vm._v("X")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "tooltip tooltip-top",
                                        domProps: {
                                          innerHTML: _vm._s(item.data.remarks)
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "bottom" }, [
                              _vm.canEdit
                                ? _c("p", { staticClass: "actions" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "comment",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showRemarkPopup($event, {
                                              index: index,
                                              data: item
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.data.remarks &&
                                              item.data.remarks != ""
                                              ? _vm.translations.day_planning
                                                  .change_remark
                                              : _vm.translations.day_planning
                                                  .add_remark
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showTooltip($event, {
                                              index: index,
                                              data: item
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translations.day_planning.modify
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-part" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.activityStartEndString(item)))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.activityDurationString(item.duration))
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  item.type === "break"
                    ? [
                        _c("div", { staticClass: "left-part" }, [
                          _c("div", { staticClass: "splitter" }, [
                            _c("div", { staticClass: "top" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-row align-items-center"
                                },
                                [
                                  _c("span", { staticClass: "icon" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translations.day_planning.break.icon
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translations.day_planning.break
                                          .label
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(item.data.name))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "bottom" }, [
                              _vm.canEdit
                                ? _c("p", { staticClass: "actions" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "comment",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showRemarkPopup($event, {
                                              index: index,
                                              data: item
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.data.remarks &&
                                              item.data.remarks != ""
                                              ? _vm.translations.day_planning
                                                  .change_remark
                                              : _vm.translations.day_planning
                                                  .add_remark
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showTooltip($event, {
                                              index: index,
                                              data: item
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translations.day_planning.modify
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-part" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.activityStartEndString(item)))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.activityDurationString(item.duration))
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "spinner-background",
                      class: { visible: _vm.externalActivitiesLoaded === false }
                    },
                    [_c("div", { staticClass: "spinner" })]
                  )
                ],
                2
              )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.tooltipClickOutside,
              expression: "tooltipClickOutside"
            }
          ],
          ref: "tooltip",
          staticClass:
            "tooltip tooltip-fixed tooltip-right px-16 py-24 px-md-32 py-md-24",
          class: { visible: _vm.tooltip.data != null },
          style: { top: _vm.tooltipTop, left: _vm.tooltipLeft }
        },
        [
          _c(
            "div",
            { staticClass: "tooltip-inner" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center mb-8"
                },
                [
                  _vm.tooltip.data && _vm.tooltip.data.type === "listed"
                    ? [
                        _c("h2", {
                          staticClass: "d-inline-block mb-0",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getExternalItem(_vm.tooltip.data)
                                ? _vm.getExternalItem(_vm.tooltip.data)
                                    .post_title
                                  ? _vm.getExternalItem(_vm.tooltip.data)
                                      .post_title
                                  : _vm.getExternalItem(_vm.tooltip.data).title
                                      .rendered
                                : ""
                            )
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tooltip.data && _vm.tooltip.data.type === "own"
                    ? [
                        _c("h2", {
                          staticClass: "d-inline-block mb-0",
                          domProps: {
                            innerHTML: _vm._s(_vm.tooltip.data.data.name)
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tooltip.data && _vm.tooltip.data.type === "catering"
                    ? [
                        _c("h2", {
                          staticClass: "d-inline-block mb-0",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.translations.day_planning.catering.label
                            )
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tooltip.data && _vm.tooltip.data.type === "break"
                    ? [
                        _c("h2", {
                          staticClass: "d-inline-block mb-0",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.translations.day_planning.break.label
                            )
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-block" },
                [
                  _vm.tooltip.data &&
                  _vm.tooltip.data.data.remarks &&
                  _vm.tooltip.data.data.remarks != ""
                    ? [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(_vm.tooltip.data.data.remarks)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "text-dark",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.showRemarkPopup($event, {
                                  index: _vm.tooltip.index
                                })
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.translations.day_planning.change_remark
                              )
                            )
                          ]
                        )
                      ]
                    : [
                        _c("p", [
                          _c(
                            "a",
                            {
                              staticClass: "text-dark",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showRemarkPopup($event, {
                                    index: _vm.tooltip.index
                                  })
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.translations.day_planning.add_remark)
                              )
                            ]
                          )
                        ])
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-n32" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center mb-16"
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v("Tijd")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.tooltipStartEndDate))])
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-n32" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center mb-16"
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v("Duur")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.tooltipDuration))])
                ]
              ),
              _vm._v(" "),
              _vm.tooltip.data && _vm.tooltip.data.type === "own"
                ? [
                    _c("hr", { staticClass: "mx-n32" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center mb-16 clickable",
                        on: {
                          click: function($event) {
                            return _vm.toggleRequest(_vm.tooltip.index)
                          }
                        }
                      },
                      [
                        _c("el-checkbox", {
                          attrs: { value: _vm.tooltip.data.data.has_requests }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "ml-12" }, [
                          _vm._v("Ik heb de hulp nodig van Inspire Your Tribe")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex" }, [
                      _vm.tooltip.data.data.requests != null &&
                      _vm.tooltip.data.data.requests != ""
                        ? _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.tooltip.data.data.requests)
                            }
                          })
                        : _c(
                            "a",
                            {
                              staticClass: "text-dark",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showRemarkPopup($event, {
                                    index: _vm.tooltip.index
                                  })
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.translations.day_planning.add_remark)
                              )
                            ]
                          )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.tooltip.data && _vm.tooltip.data.type === "break"
                ? [
                    _c("hr", { staticClass: "mx-n32" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center mb-16 clickable",
                        on: {
                          click: function($event) {
                            return _vm.toggleCatering(_vm.tooltip.index)
                          }
                        }
                      },
                      [
                        _c("el-checkbox", {
                          attrs: { value: _vm.tooltip.data.data.needs_catering }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "ml-12" }, [
                          _vm._v("Catering toevoegen aan mijn break")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.tooltip.data.data.needs_catering
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.tooltip.data.data.catering_remarks
                            )
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-n32" }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-dark",
                    on: {
                      click: function($event) {
                        return _vm.deleteActivity(_vm.tooltip.index)
                      }
                    }
                  },
                  [_vm._v("Activiteit verwijderen")]
                )
              ])
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }